import cn from 'classnames';
import { Image } from '../../../../../components/Image/Image';
import styles from './PaymentMethodCard.module.scss';
import { useEffect, useState } from 'react';
import { StripeCardForm } from '../StripeCardForm/StripeCardForm';
import { useNavigate } from 'react-router';
import { ampPurchase, ampPurchaseStatus } from '../../../../../utils/AmplitudeEvents';
export const PaymentMethodCard =({ data, method,email,currency, status, onClick, onAvailable })=>{
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  let isAvailable = true; 
  useEffect(() => {
    if (isAvailable && onAvailable) {
      onAvailable();
    }
  }, [isAvailable, onAvailable]);

  const  {name, icon, list, securedText} = method;


  if(!method || !data || !isAvailable) return;
  // console.log(data)
  return(
    <div className={cn(
      styles.wrapper,
      status ==='open' && styles.open
      )}
      onClick={isAvailable ? onClick : undefined}
      tabIndex={isAvailable ? 0 : -1}
      aria-disabled={!isAvailable}
      >
      <div className={styles.header}>
        <div className={styles.bullet}></div>
        {name && <div className={styles.methodName}>{name}</div>}
        {icon && <Image src={icon} className={styles.icon}/>}
      </div>
      <div className={styles.content}>
        {list && 
          <div className={styles.listWrapper}>
            <ul className={styles.list}>
              {list.map((item,index)=>{
                return <li key={index} className={styles.item}>{item}</li>
              })}
            </ul>
          </div>
        }
        {/* paymentElements */}
        <div className={styles.paymentElements}>
        <StripeCardForm onSuccess={async(result) => {
          ampPurchaseStatus('complete');
          localStorage.setItem('planInfo', JSON.stringify(data));
          ampPurchase({currency, payment_method: 'card', price: data.salePrice/100, productId: data.priceID, quantity: 1});
          navigate(`/registration/?session_id=${result.subscriptionId}`);
        }} 
        email={email}
        data={data}
        currency={currency}
        setMessage={setMessage}
        />
        </div>
        {/* paymentElements */}
        {message && <div className={styles.message}>{message}</div>}
        {securedText && <div className={styles.securedText}>{securedText}</div>}
      </div>
      
    </div>
  )
}